import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";

import moment from "moment";
const VehicleRegistrationList = (props) => {
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }
        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteData } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
        setDeleteLoading(data);
        const updatedApproveData = {
          ...data,
          status: 0,
          serviceId: sId,
        };

        deleteData(
          {
            url: "/api/vehicleMachineEquipRegistratn/",
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
            setDeleteLoading(false);
          },
          () => {
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/vehicleMachineEquipRegistratn/?orgId=${localStorage.getItem(
          "orgId"
        )}&&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.vmerId;

    getDetailView(
      {
        url: `/api/vehicleMachineEquipRegistratn/?orgId=${localStorage.getItem(
          "orgId"
        )}&vmerId=${Id}`,
      },
      (res) => {
        //console.log("Detail View", res);
        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.vmerId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/approveVehicleMachinenEquipment/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="modal-heading-bar" style={{ width: "750px" }}>
          <div style={{ width: "750px" }}>
            <div className="text-right">
              <button type="button" onClick={() => closeModal(false)}>
                {"\u2715"}
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                {" "}
                <h2> Vehicle Registration Detail</h2>
              </div>
            </div>

            {selectedData && (
              <div>

                {/* Row 1 - Dates */}
                <div className="row">
                  <div className="col-md-3">
                    <label>Date</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.vmerDate}</label>
                  </div>

                  <div className="col-md-3">
                    <label>Driver Name</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.assignedPersonDriverName}</label>
                  </div>

                  {/* <div className="col-md-3">
        <label>Purchase Date</label>
      </div>
      <div className="col-md-3">
        <label>: {selectedData.vmePurchaseDate}</label>
      </div> */}
                </div>

                {/* Row 2 - Last Maintenance */}
                <div className="row">

                  {/* <div className="col-md-3">
                    <label>Driver Contact No</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.assignedPersonContactNo}</label>
                  </div> */}

                  {/* <div className="col-md-3">
                    <label>Fuel</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.fuelProductName}</label>
                  </div> */}

                  {/* <div className="col-md-3">
        <label>Last Maintenance Date</label>
      </div>
      <div className="col-md-3">
        <label>: {selectedData.lastMaintenenceDate}</label>
      </div> */}
                </div>

                {/* Row 3 - Contact & Fuel */}
                <div className="row">
                  <div className="col-md-3">
                    <label>Vehicle Code</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.VehicleCode}</label>
                  </div>

                  <div className="col-md-3">
                    <label>Vehicle  Name</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.vmeModelName}</label>
                  </div>
                </div>

                {/* Row 4 - Vehicle Details */}
                <div className="row">
                  {/* <div className="col-md-3">
                    <label>Category</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.vmeTypeCategory}</label>
                  </div> */}

                  <div className="col-md-3">
                    <label>Vehicle No</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.vmeNo}</label>
                  </div>
                  <div className="col-md-3">
                    <label>Ownership Type</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.vmeOwnershipType}</label>
                  </div>
                </div>

                {/* Row 5 - Category & No */}
                <div className="row">
                  

                  <div className="col-md-3">
                    <label>Remark</label>
                  </div>
                  <div className="col-md-3">
                    <label>: {selectedData.remark}</label>
                  </div>

                  {/* <div className="col-md-3">
        <label>Ownership</label>
      </div>
      <div className="col-md-3">
        <label>: {selectedData.vmeOwnership}</label>
      </div> */}
                </div>

                {/* Row 6 - Ownership */}
                <div className="row">
                  {/* <div className="col-md-3">
        <label>Manufacture Year</label>
      </div>
      <div className="col-md-3">
        <label>: {selectedData.vmeManufacYear}</label>
      </div> */}
                </div>

              </div>
            )}
          </div>
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-1">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Vehicle Registration Details
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Vehicle Registration
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            {/* <th>Time Stamp</th> */}
                            <th>Assigned Employee</th>
                            <th>Registration No</th>
                            <th>Vehicle  Name</th>
                            {/* <th>Last Maintanence</th> */}
                            <th>Approval</th>
                            {canEdit === "block" && <th>Edit</th>}
                            {canDelete === "block" && <th>Delete</th>}
                            {canView === "block" && <th>View</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.vmerDate}</td>
                                {/* <td>
                                  {moment(x.timeStamp, "HH:mm:ss").format(
                                    "hh:mm A"
                                  )}
                                </td> */}
                                <td>{x.employeeName}</td>
                                <td>{x.VehicleCode}</td>
                                <td>{x.vmeModelName}</td>
                                {/* <td>{x.lastMaintenenceDate}</td> */}
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    // disabled={
                                    //   x.nextlevel == 1
                                    //     ? x.allowApproveUserId == loginUserId
                                    //       ? false
                                    //       : true
                                    //     : x.approved == 0 &&
                                    //       x.reportingId == loginUserId
                                    //       ? false
                                    //       : true
                                    // }
                                    disabled={false}
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => {
                                        props.update(x);
                                        props.sId(serviceId);
                                        props.addForm(true);
                                      }}
                                      disabled={x.approved === 1 || x.approved === 2}
                                      style={{
                                        opacity: x.approved === 1 || x.approved === 2 ? 0.4 : 1,
                                        cursor: x.approved === 1 || x.approved === 2 ? "not-allowed" : "pointer",
                                      }}
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}
                                <td>
                                  {deleteLoading === x ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) => deleteOperation(e, x)}
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Vehicle Registration Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default VehicleRegistrationList;
